import type {CountryCode} from '@commercial-website/data-layer/locale'
import flagAT from '@commercial-website/icons/assets/flags-legacy/flag-at.svg'
import flagBE from '@commercial-website/icons/assets/flags-legacy/flag-be.svg'
import flagDE from '@commercial-website/icons/assets/flags-legacy/flag-de.svg'
import flagDK from '@commercial-website/icons/assets/flags-legacy/flag-dk.svg'
import flagEE from '@commercial-website/icons/assets/flags-legacy/flag-ee.svg'
import flagES from '@commercial-website/icons/assets/flags-legacy/flag-es.svg'
import flagFI from '@commercial-website/icons/assets/flags-legacy/flag-fi.svg'
import flagFR from '@commercial-website/icons/assets/flags-legacy/flag-fr.svg'
import flagGB from '@commercial-website/icons/assets/flags-legacy/flag-gb.svg'
import flagIE from '@commercial-website/icons/assets/flags-legacy/flag-ie.svg'
import flagIT from '@commercial-website/icons/assets/flags-legacy/flag-it.svg'
import flagLU from '@commercial-website/icons/assets/flags-legacy/flag-lu.svg'
import flagNL from '@commercial-website/icons/assets/flags-legacy/flag-nl.svg'
import flagNO from '@commercial-website/icons/assets/flags-legacy/flag-no.svg'
import flagPT from '@commercial-website/icons/assets/flags-legacy/flag-pt.svg'
import flagSE from '@commercial-website/icons/assets/flags-legacy/flag-se.svg'
import flagUS from '@commercial-website/icons/assets/flags-legacy/flag-us.svg'
import rebrandFlagAT from '@commercial-website/icons/assets/flags/flag-at.svg'
import rebrandFlagBE from '@commercial-website/icons/assets/flags/flag-be.svg'
import rebrandFlagDE from '@commercial-website/icons/assets/flags/flag-de.svg'
import rebrandFlagDK from '@commercial-website/icons/assets/flags/flag-dk.svg'
import rebrandFlagEE from '@commercial-website/icons/assets/flags/flag-ee.svg'
import rebrandFlagES from '@commercial-website/icons/assets/flags/flag-es.svg'
import rebrandFlagFI from '@commercial-website/icons/assets/flags/flag-fi.svg'
import rebrandFlagFR from '@commercial-website/icons/assets/flags/flag-fr.svg'
import rebrandFlagGB from '@commercial-website/icons/assets/flags/flag-gb.svg'
import rebrandFlagIE from '@commercial-website/icons/assets/flags/flag-ie.svg'
import rebrandFlagIT from '@commercial-website/icons/assets/flags/flag-it.svg'
import rebrandFlagLU from '@commercial-website/icons/assets/flags/flag-lu.svg'
import rebrandFlagNL from '@commercial-website/icons/assets/flags/flag-nl.svg'
import rebrandFlagNO from '@commercial-website/icons/assets/flags/flag-no.svg'
import rebrandFlagPT from '@commercial-website/icons/assets/flags/flag-pt.svg'
import rebrandFlagSE from '@commercial-website/icons/assets/flags/flag-se.svg'
import rebrandFlagUS from '@commercial-website/icons/assets/flags/flag-us.svg'

export const countryFlags: Record<CountryCode, string> = {
    gb: flagGB,
    us: flagUS,
    dk: flagDK,
    ee: flagEE,
    es: flagES,
    fr: flagFR,
    de: flagDE,
    se: flagSE,
    ie: flagIE,
    at: flagAT,
    fi: flagFI,
    be: flagBE,
    nl: flagNL,
    it: flagIT,
    pt: flagPT,
    no: flagNO,
    lu: flagLU,
}

// Rebrand flag set (24×24, circular) consumed by the locale switcher. The `countryFlags` set
// above stays in use by pleo-map, which expects the rectangular flag artwork.
export const rebrandCountryFlags: Record<CountryCode, string> = {
    gb: rebrandFlagGB,
    us: rebrandFlagUS,
    dk: rebrandFlagDK,
    ee: rebrandFlagEE,
    es: rebrandFlagES,
    fr: rebrandFlagFR,
    de: rebrandFlagDE,
    se: rebrandFlagSE,
    ie: rebrandFlagIE,
    at: rebrandFlagAT,
    fi: rebrandFlagFI,
    be: rebrandFlagBE,
    nl: rebrandFlagNL,
    it: rebrandFlagIT,
    pt: rebrandFlagPT,
    no: rebrandFlagNO,
    lu: rebrandFlagLU,
}
